import React, { useState, useEffect } from 'react';
import { DOCUMENT_MARKUP } from '@Constants/types';
import store from '@Store';
import { executeAllHits, executeAllHits2 } from '@Service/wordApiService';
import { getSkipCount } from '@Utils/commonUtils';

function callAPI() {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
        setTimeout(() => resolve(), 1000);
    });
}

let hitSkipTotal = 0;
function useBackgroundService() {
    const [backgroundService, setBackgroundService] = useState(null);

    useEffect(() => {
        const bgService = setInterval(() => {
            // eslint-disable-next-line
            callAPI().then(() => {
                if (hitSkipTotal === 0) {
                    const skip = getSkipCount();
                    hitSkipTotal += skip;
                    const rootReducer = store.getState();
                    const { document } = rootReducer;
                    const {
                        mappedParagraphsScorecard,
                        mappedParagraphsScorecard2,
                        isMarkupCancelling
                    } = document;

                    if (isMarkupCancelling) {
                        return;
                    }

                    // Full Paragraphs replaced with content controls
                    if (mappedParagraphsScorecard && mappedParagraphsScorecard.length > 0) {
                        const nextBatch = mappedParagraphsScorecard.splice(0, 20);
                        executeAllHits(nextBatch);

                        // update reducer with the reduced array
                        store.dispatch({
                            type: DOCUMENT_MARKUP.BACKGROUND_PROCESS_SCORECARD,
                            payload: {
                                mappedParagraphs: mappedParagraphsScorecard,
                                mappedParagraphs2: mappedParagraphsScorecard2
                            }
                        });

                        return;
                    }

                    // replaced jump-to hits with content controls
                    if (mappedParagraphsScorecard2 && mappedParagraphsScorecard2.length > 0) {
                        const nextBatch = mappedParagraphsScorecard2.splice(0, 1);
                        executeAllHits2(nextBatch);

                        // update reducer with the reduced array
                        store.dispatch({
                            type: DOCUMENT_MARKUP.BACKGROUND_PROCESS_SCORECARD,
                            payload: {
                                mappedParagraphs: mappedParagraphsScorecard,
                                mappedParagraphs2: mappedParagraphsScorecard2
                            }
                        });
                    }
                } else {
                    hitSkipTotal = hitSkipTotal - 1;
                }
            });
        }, 1100);

        function cleanup() {
            clearInterval(bgService);
        }

        setBackgroundService(bgService);

        return cleanup;
    }, []);

    return backgroundService;
}

function HitsProcess() {
    useBackgroundService();

    return <></>;
}

export default HitsProcess;
